import * as React from 'react';

import Retracked from 'js/app/retracked';

import useArticleUrlData from 'bundles/shared-articles/hooks/useArticleUrlData';
import ArticlePage from 'bundles/unified-seo-content-common/pages/article/ArticleContentPage';
import ArticleContentPageDataProvider from 'bundles/unified-seo-content-common/providers/article/ArticleContentPageDataProvider';

const ArticleContentPageRoot = () => {
  const { slug, isPreview, subfolderLocaleCode } = useArticleUrlData();

  return (
    <ArticleContentPageDataProvider slug={slug} isPreview={isPreview} subfolderLocaleCode={subfolderLocaleCode}>
      {ArticlePage}
    </ArticleContentPageDataProvider>
  );
};

export default Retracked.createTrackedContainer(() => ({
  namespace: {
    app: 'articles',
    page: 'article_page',
  },
}))(ArticleContentPageRoot);
